import React from "react"
import * as Yup from "yup"
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Toast,
  ToastBody,
} from "reactstrap"

import Spinners from "components/Common/Spinner"

import close from "../../../assets/images/icons/close.svg"
import toast from "react-hot-toast"
import BgPatternImage from "../../../assets/images/background-pattern.png"
import { useFormik } from "formik"
import { sanitizeIntegerInput } from "helpers/common"
import { useGetDocSignersQuery } from "store/api/signers/signers.api"

const defaultValues = {
  lockin_period: "",
  notice_period: "0",
  signer: "",
}

function ApproveConfirmationModal({
  id,
  icdData,
  open,
  setOpen,
  isLoading,
  title = "Approve Request",
  description = "Are you sure you want to approve request?",
  onApprove,
  onSuccess,
  onClose,
}) {
  const { data: docSigners } = useGetDocSignersQuery()
  const handleSend = async (values) => {
    try {
      const { success, message } = await onApprove({
        id,
        ...values,
        // created_by: icdData.created_by,
      }).unwrap()
      if (success) {
        onSuccess()
        onClose()
        toast.success(message, { id: "toasterMessage" })
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toasterMessage" })
    }
  }

  const validation = useFormik({
    initialValues: {
      ...defaultValues,
      lockin_period: String(icdData?.lockin_period),
    },
    validationSchema: Yup.object({}),

    onSubmit: (values) => {
      handleSend(values)
    },
  })

  return (
    <>
      {open && <div className="toast-overlay" />}
      <div
        className="position-fixed top-0 start-50 translate-middle-x p-3"
        style={{ zIndex: "99999" }}
      >
        <Toast isOpen={open} role="alert" className="alert-card-box-wrapper">
          <div className="bg-pattern">
            <img src={BgPatternImage} alt="" />
          </div>
          <ToastBody>
            <Form
              className="form-horizontal"
              onSubmit={(e) => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <div className="delete-card-wrapper">
                <div className="inner-box success">
                  <i className="mdi mdi-check-circle-outline"></i>
                </div>
                <div>
                  <h4>{title}</h4>
                  {description}
                </div>
                <div className="close-icon" onClick={() => setOpen(false)}>
                  <img src={close} alt="" />
                </div>
              </div>
              {icdData?.created_by === "INVESTOR" && (
                <Row>
                  <Col xl={12}>
                    <Label className="col-form-label">
                      Lock-in (in days)
                      <span className="error">*</span>
                    </Label>
                    <Input
                      name="lockin_period"
                      type="text"
                      className="form-control"
                      id="lockin_period"
                      // disabled
                      placeholder="Lock-in"
                      min={1}
                      value={validation.values.lockin_period}
                      onChange={(e) =>
                        sanitizeIntegerInput(
                          e,
                          validation.setFieldValue,
                          "lockin_period"
                        )
                      }
                      invalid={
                        validation.touched.lockin_period &&
                        validation.errors.lockin_period
                          ? true
                          : false
                      }
                    />
                    {validation.errors.lockin_period ? (
                      <FormFeedback type="invalid">
                        {validation.errors.lockin_period}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col xl={12}>
                    <Label className="col-form-label">
                      Notice Period (in days)
                      <span className="error">*</span>
                    </Label>
                    <Input
                      name="notice_period"
                      type="text"
                      className="form-control"
                      id="notice_period"
                      min={0}
                      placeholder="Notice Period"
                      value={validation.values.notice_period}
                      onChange={(e) =>
                        sanitizeIntegerInput(
                          e,
                          validation.setFieldValue,
                          "notice_period"
                        )
                      }
                      invalid={
                        validation.touched.notice_period &&
                        validation.errors.notice_period
                          ? true
                          : false
                      }
                    />
                    {validation.errors.notice_period ? (
                      <FormFeedback type="invalid">
                        {validation.errors.notice_period}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </Row>
              )}
              <Row>
                <Col xl={12}>
                  <Label className="col-form-label" htmlFor="signer">
                    Select Signatory
                    <span className="error">*</span>
                  </Label>
                  <select
                    id="signer"
                    name="signer"
                    className="form-select"
                    value={validation.values.signer}
                    onChange={validation.handleChange}
                  >
                    <option value=""> Select Signatory</option>
                    {docSigners?.data?.map((item, index) => (
                      <option key={`doc_signer_${index}`} value={item.phone_no}>
                        {item.name} ({item.phone_no})
                      </option>
                    ))}
                  </select>
                  {validation.errors.signer ? (
                    <FormFeedback type="invalid">
                      {validation.errors.signer}
                    </FormFeedback>
                  ) : null}
                </Col>
              </Row>
              <div className="mt-3 pt-3 mb-0 button-wrapper buttons position-relative z-2">
                <button
                  onClick={() => onClose()}
                  type="button"
                  className="cancel"
                >
                  Cancel
                </button>
                <Button type="submit" className="approve btn btn-secondary">
                  {isLoading ? <Spinners /> : "Approve Request"}
                </Button>
              </div>
            </Form>
          </ToastBody>
        </Toast>
      </div>
    </>
  )
}

export default ApproveConfirmationModal
